import { isEqual, pick } from 'lodash';
import { Contact } from '../../../../providers/api/dtos';

export const hasContactChanged = (
  prev: Partial<Contact>,
  curr: Partial<Contact>,
  comparisonKeys: (keyof Contact)[],
): boolean => {
  const cleanPrev = pick(prev, comparisonKeys);
  const cleanCurr = pick(curr, comparisonKeys);

  return !isEqual(cleanPrev, cleanCurr);
};
